declare global {
  interface Window {
    $crisp: unknown[]
    CRISP_WEBSITE_ID: string
    CRISP_RUNTIME_CONFIG: Record<string, string>
  }
}

export default defineNuxtPlugin((nuxtApp) => {
  const { CC_ID, ENVIRONMENT, market } = nuxtApp.$config.public

  if (CC_ID && ENVIRONMENT === 'production') {
    window.setTimeout(() => {
      window.$crisp = []
      window.CRISP_WEBSITE_ID = CC_ID
      window.CRISP_RUNTIME_CONFIG = {
        locale: localeToLangInfo(market)?.code,
      }

      /* eslint-disable */
      ;(function () {
        var d = document;
        var s = d.createElement('script');
        s.src = 'https://client.crisp.chat/l.js';
        s.async = true;
        d.getElementsByTagName('head')[0].appendChild(s);
      })();
      window.$crisp.push(['safe', true])
      /* eslint-enable */
    }, 10000)
  }
})